import { render, staticRenderFns } from "./LogisticsOptions.vue?vue&type=template&id=f8aa0f7c"
import script from "./LogisticsOptions.vue?vue&type=script&lang=js"
export * from "./LogisticsOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports